import { InjectionToken } from '@angular/core';

export const COMMON_ERRORS_TOKEN = new InjectionToken<Record<string, string>>(
  'Common errors map token'
);
